import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { ROUTES } from '../resources/routes-constants'
import '../pages/topnav.css'

const navClassName = ({ isActive }: { isActive: boolean }) => `nav-link${isActive ? ' active' : ''}`

const TopNav: React.FC = () => {
    return (
        <header>
            <a className="skip-link" href="#main-content">Skip to main content</a>
            <nav className="mainnav navbar navbar-expand-xxl navbar-dark fixed-top" id="mainNav" aria-label="Main navigation">
                <div className="container-fluid flex-wrap">
                    <Link className="navbar-brand" to={ROUTES.MAINPAGE_ROUTE}>
                        <span className="navbar-title d-none d-sm-inline">The House of Afros, Capes and Curls</span>
                        <span className="navbar-title d-sm-none">HOACC</span>
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarResponsive"
                        aria-controls="navbarResponsive"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        Menu
                        <i className="fas fa-bars ms-1" aria-hidden="true"></i>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav ms-auto py-4 py-lg-0">
                            <li className="nav-item">
                                <NavLink className={navClassName} to={ROUTES.MAINPAGE_ROUTE}>
                                    Home
                                </NavLink>
                            </li>
                            <li className="nav-item dropdown">
                                <button
                                    type="button"
                                    className="nav-link dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    About
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.ABOUT_ROUTE}>
                                            About The House
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.MEETTEAM_ROUTE}>
                                            Meet the Team
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown">
                                <button
                                    type="button"
                                    className="nav-link dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Community
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.COMMUNITYENGAGEMENT_ROUTE}>
                                            Engagement
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.EDUCATION_ROUTE}>
                                            Education
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item dropdown">
                                <button
                                    type="button"
                                    className="nav-link dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Events
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.SPECIALEVENTS_ROUTE}>
                                            Event Calendar
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.SIGNATUREEVENTS_ROUTE}>
                                            Signature Events
                                        </Link>
                                    </li>
                                    {/* Hidden for now
                                    <li>
                                        <Link className="dropdown-item" to={ROUTES.JUNETEENTH_ROUTE}>
                                            Juneteenth
                                        </Link>
                                    </li>
                                    */}
                                </ul>
                            </li>
                            <li className="nav-item">
                                <NavLink className={navClassName} to={ROUTES.BOOKCLUB_ROUTE}>
                                    Book Club
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href={ROUTES.STORE_ROUTE} target="_blank" rel="noopener noreferrer">
                                    Tickets & Store
                                </a>
                            </li>
                        </ul>

                        <span className="d-flex donate-button-wrapper">
                            <a
                                href={`${ROUTES.MAINPAGE_ROUTE}#donate`}
                                className="btn btn-success donate-button"
                                aria-label="Donate to HOACC"
                            >
                                Donate
                            </a>
                        </span>
                    </div>
                </div>
            </nav>
        </header>
    )
}

export default TopNav
